//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Returns short information about Doctor profile
 */
export function getDoctorProfileInfo(config?: AxiosRequestConfig | undefined): Promise<Types.DoctorProfileDto> {
    let url_ = getBaseUrl() + "/api/profile/doctor";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDoctorProfileInfo,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDoctorProfileInfo(_response);
    });
}

function processGetDoctorProfileInfo(response: AxiosResponse): Promise<Types.DoctorProfileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DoctorProfileDto.fromJS(resultData200);
        return Promise.resolve<Types.DoctorProfileDto>(result200);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = Types.ProblemDetails.fromJS(resultData403);
        return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DoctorProfileDto>(null as any);
}

/**
 * Returns short information about patient profile
 */
export function getPatientProfileInfo(config?: AxiosRequestConfig | undefined): Promise<Types.PatientDto> {
    let url_ = getBaseUrl() + "/api/profile/patient";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientProfileInfo,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientProfileInfo(_response);
    });
}

function processGetPatientProfileInfo(response: AxiosResponse): Promise<Types.PatientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientDto.fromJS(resultData200);
        return Promise.resolve<Types.PatientDto>(result200);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientDto>(null as any);
}
let _requestConfigGetDoctorProfileInfo: Partial<AxiosRequestConfig> | null;
export function getGetDoctorProfileInfoRequestConfig() {
  return _requestConfigGetDoctorProfileInfo;
}
export function setGetDoctorProfileInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctorProfileInfo = value;
}
export function patchGetDoctorProfileInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctorProfileInfo = patch(_requestConfigGetDoctorProfileInfo ?? {});
}

let _requestConfigGetPatientProfileInfo: Partial<AxiosRequestConfig> | null;
export function getGetPatientProfileInfoRequestConfig() {
  return _requestConfigGetPatientProfileInfo;
}
export function setGetPatientProfileInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientProfileInfo = value;
}
export function patchGetPatientProfileInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientProfileInfo = patch(_requestConfigGetPatientProfileInfo ?? {});
}